import dayjs from 'dayjs';

/**
 * Placeholder API for HR employee dashboard features not yet on the backend.
 * Replace these functions with real `services/api` calls when endpoints exist.
 */

const hashSeed = (str) => str.split('').reduce((a, c) => a + c.charCodeAt(0), 0);

/**
 * @returns {Promise<{ days: Array<{ date: string, status: 'present'|'absent'|'leave'|'weekend' }> }>}
 */
export const fetchEmployeeAttendanceCalendarDummy = async (employeeId, startDate, endDate) => {
  await new Promise((r) => setTimeout(r, 120));

  let start = startDate ? dayjs(startDate) : dayjs().startOf('month');
  let end = endDate ? dayjs(endDate) : dayjs();
  if (start.isAfter(end, 'day')) {
    const t = start;
    start = end;
    end = t;
  }
  const days = [];

  let d = start.clone();
  while (d.isBefore(end, 'day') || d.isSame(end, 'day')) {
    const dow = d.day();
    const isWeekend = dow === 0 || dow === 6;
    const seed = hashSeed(String(employeeId) + d.format('YYYY-MM-DD'));

    let status;
    if (isWeekend) {
      status = 'weekend';
    } else {
      const roll = seed % 10;
      if (roll < 1) status = 'absent';
      else if (roll < 2) status = 'leave';
      else status = 'present';
    }

    days.push({ date: d.format('YYYY-MM-DD'), status });
    d = d.add(1, 'day');
  }

  return { days };
};

/**
 * Monthly net (or gross) payment amounts — one bar per month in range.
 * @returns {Promise<{ monthlyPayments: Array<{ month: string, monthKey: string, amount: number }> }>}
 */
export const fetchEmployeePayrollMonthlyDummy = async (employeeId, startDate, endDate) => {
  await new Promise((r) => setTimeout(r, 120));

  const end = endDate ? dayjs(endDate) : dayjs();
  let start = startDate ? dayjs(startDate) : end.subtract(11, 'month').startOf('month');

  if (start.isAfter(end, 'month')) {
    start = end.clone().startOf('month');
  }

  const monthlyPayments = [];
  let m = start.startOf('month');
  const endMonth = end.endOf('month');

  while (m.isBefore(endMonth, 'month') || m.isSame(endMonth, 'month')) {
    const seed = hashSeed(String(employeeId) + m.format('YYYY-MM'));
    const amount = 2200 + (seed % 4800) + (seed % 7) * 125;

    monthlyPayments.push({
      month: m.format('MMM YYYY'),
      monthKey: m.format('YYYY-MM'),
      amount,
    });
    m = m.add(1, 'month');
  }

  return { monthlyPayments };
};
